import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-fc-code-popup',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './fc-code-popup.component.html',
  styleUrl: './fc-code-popup.component.scss',
})
export class FcCodePopupComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<FcCodePopupComponent>
  ) {}
  ngOnInit(): void {}
  onContinueClick() {
    this.dialogRef.close(true);
  }
}
